import {Colors} from '@adsk/bim360-matrix-react-helpers/es/consts';
import i18n from '../utils/i18n';
import {STATUS_SETS} from './issue-types';

export const STATUS_DRAFT = 'draft';
export const STATUS_OPEN = 'open';
export const STATUS_ANSWERED = 'answered';
export const STATUS_CLOSED = 'closed';
export const STATUS_WORK_COMPLETED = 'work_completed';
export const STATUS_READY_TO_INSPECT = 'ready_to_inspect';
export const STATUS_NOT_APPROVED = 'not_approved';
export const STATUS_IN_DISPUTE = 'in_dispute';
export const STATUS_VOID = 'void';

export const ISSUES_SORTED_STATUSES = [STATUS_DRAFT, STATUS_OPEN, STATUS_ANSWERED, STATUS_CLOSED];
const issuesStatusSortOrder = {
  [STATUS_DRAFT]: 0,
  [STATUS_OPEN]: 1,
  [STATUS_ANSWERED]: 2,
  [STATUS_CLOSED]: 3
};
export const issuesSortStatus = (a, b) => issuesStatusSortOrder[a] > issuesStatusSortOrder[b];

export const QUALITY_ISSUES_SORTED_STATUSES = [
  STATUS_DRAFT,
  STATUS_OPEN,
  STATUS_ANSWERED,
  STATUS_WORK_COMPLETED,
  STATUS_READY_TO_INSPECT,
  STATUS_NOT_APPROVED,
  STATUS_IN_DISPUTE,
  STATUS_CLOSED,
  STATUS_VOID
];

export const toStatusOption = status => ({label: i18n.t(`status.${status}`), value: status});

export const getFullStatusOptions = () => QUALITY_ISSUES_SORTED_STATUSES.map(toStatusOption);

export const statusColorMapping = {
  [STATUS_DRAFT]: Colors.GRAY_DARK,
  [STATUS_OPEN]: Colors.YELLOW,
  [STATUS_ANSWERED]: Colors.BLUE,
  [STATUS_CLOSED]: Colors.GRAY,
  [STATUS_WORK_COMPLETED]: Colors.BLUE,
  [STATUS_READY_TO_INSPECT]: Colors.PURPLE,
  [STATUS_NOT_APPROVED]: Colors.RED,
  [STATUS_IN_DISPUTE]: Colors.RED,
  [STATUS_VOID]: Colors.GRAY
};

export const availableStatusesOnCreate = [STATUS_DRAFT, STATUS_OPEN];

export const issueTemplatesStatuses = [STATUS_DRAFT, STATUS_OPEN];

export const statusesByStatusSets = {
  [STATUS_SETS.BASIC]: [STATUS_DRAFT, STATUS_OPEN, STATUS_ANSWERED, STATUS_CLOSED, STATUS_VOID],
  [STATUS_SETS.FIELD]: [
    STATUS_DRAFT,
    STATUS_OPEN,
    STATUS_WORK_COMPLETED,
    STATUS_READY_TO_INSPECT,
    STATUS_NOT_APPROVED,
    STATUS_IN_DISPUTE,
    STATUS_CLOSED
  ]
};
